import { getManagementPeripheralLinks } from '@/services/company';

export default {
  namespace: 'Devices_managementPeripheralLinks',
  state: {
    linkDetail: [],
  },

  effects: {
    /** 获取管理管理系统终端外设链路 */
    *fetch({ payload }, { call, put }) {
      const { data } = yield call(getManagementPeripheralLinks, payload);
      yield put({
        type: 'saveLink',
        payload: data,
      });
    },
  },

  reducers: {
    saveLink(state, action) {
      return {
        ...state,
        data: action.payload,
      };
    },
  },
};
